import DataGrid, { IColumnProps } from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { SelectionChangedEvent } from "devextreme/ui/data_grid";
import React from "react";
import { cpNewService, cpNewStore } from "../../api";
import { createEmptyStore, DataMap, ModuleConfig } from "../../base";
import { createGridOptions, remoteReadOnlyGridOptions, StdGrid } from "../../components";
import { CpNewModel } from "../../models";

export interface CpNewGridProps {
    deferLoad: boolean;
    permissions: DataMap<boolean>;
    onModelSelected: (model: CpNewModel) => void;
    onRowChecked: (ids: number[]) => void;
    onButtonClick: (model: CpNewModel, name: string) => void;
}

interface CpNewGridState {
    store: CustomStore;
    columns: IColumnProps[];
}

export default class CpNewGrid extends React.Component<CpNewGridProps, CpNewGridState> {
    moduleName: ModuleConfig = {
        moduleName: "CpNew",
        children: {
            "batch": "CpBatch"
        } 
    };

    gridRef = React.createRef<DataGrid>();
    gridOptions = createGridOptions("cpNews", this.gridRef, remoteReadOnlyGridOptions);

    constructor(props: Readonly<CpNewGridProps>) {
        super(props);

        this.state = {
            store: props.deferLoad ? createEmptyStore() : cpNewStore,
            columns: [
                { dataField: "createdAt", dataType: "datetime" },
                { dataField: "updatedAt", dataType: "datetime" },
                { dataField: "batch.batchCode" },
                { dataField: "barcode" },
                { dataField: "produceDate", dataType: "date" },
                { dataField: "enterDate", dataType: "date" },
                { dataField: "nextInspectDate", dataType: "date" },
                { dataField: "code" },
                { dataField: "bottleType" },
                { dataField: "vendor" },
                { dataField: "weight" },
                { dataField: "note" }
            ]
        }

        this.gridOptions.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.gridOptions.onRowDblClick = (e) => this.props.onButtonClick(e.data, "edit");
    }

    load(batchId: number) {
        this.setState({
            store: cpNewService.getDxData(batchId)
        });
    }

    onSelectionChanged(e: SelectionChangedEvent) {
        if (e.selectedRowsData.length === 1) {
            this.props.onModelSelected(e.selectedRowsData[0]);
        } else {
            this.props.onModelSelected({});    // 为避免混乱，多选不能编辑
        }

        this.props.onRowChecked(e.selectedRowKeys);
    }

    refresh() {
        this.gridRef.current?.instance.refresh();
    }

    render() {
        return (
            <StdGrid
                moduleName={this.moduleName}
                gridRef={this.gridRef}
                dataSource={this.state.store}
                options={this.gridOptions}
                columns={this.state.columns} />
        )
    }
}